<div class="classifications-view">
  <div class="actions-bar">
    <span class="results-count">
      {{ classifications.length }} {{ 'RESULT.CLASSIFICATIONS.COUNT' | translate }}
    </span>
    <button class="download-button" (click)="onDownload()" [title]="'BUTTON.DOWNLOAD' | translate">
      <fa-icon [icon]="icons.faDownload"></fa-icon>
      <span>JSON</span>
    </button>
  </div>

  <div class="classifications-list">
    @for (item of classifications; track item.id) {
    <div class="classification-item"
         [class.dimmed]="item.score === 0"
         [class.clickable]="item.page !== undefined"
         [class.score-high]="item.score >= 0.7"
         [class.score-mid]="item.score >= 0.3 && item.score < 0.7"
         [class.score-low]="item.score < 0.3"
         (click)="onItemClick(item)">
      <div class="item-header">
        <span class="item-id">{{ item.id }}</span>
        <div class="item-meta">
          @if (item.page) {
          <span class="page-badge">
            {{ 'RESULT.CLASSIFICATIONS.PAGE' | translate: { page: item.page } }}
          </span>
          }
          <span class="score-badge" [style.background-color]="getScoreColor(item.score) + '22'" [style.color]="getScoreColor(item.score)" [style.border-color]="getScoreColor(item.score) + '55'">
            {{ formatScore(item.score) }}
          </span>
        </div>
      </div>
      @if (item.justification) {
      <p class="item-justification">{{ item.justification }}</p>
      }
    </div>
    }

    @if (classifications.length === 0) {
    <div class="empty-state">
      <p>{{ 'RESULT.CLASSIFICATIONS.EMPTY' | translate }}</p>
    </div>
    }
  </div>
</div>
